import { Column } from 'src/app/model/common/column';

export const COMMERCIAL_OPERATIONAL_NOTES_SEARCH_TABLE_DEFINITION: Column[] = [
  {
    field: 'updatedAt',
    header: 'COMMERCIAL_SERVICES.LABEL.CREATED_UPDATED_AT',
    mobileHeader: 'COMMERCIAL_SERVICES.LABEL.CREATED_UPDATED_AT',
    formatPattern: 'calendar',
    type: 'calendar',
    width: '10%',
    sortable: true,
    filterable: false,
    matchMode: 'contains',
    dateFormat: 'yyyy-MM-dd hh:mm aaa',
  },
  {
    field: 'facilityName',
    header: 'LOCATION.LABEL.FACILITY_NAME',
    mobileHeader: 'LOCATION.LABEL.FACILITY_NAME',
    formatPattern: 'text',
    type: 'input',
    width: '16%',
    sortable: true,
    filterable: true,
    matchMode: 'contains',
  },
  {
    field: 'facilityId',
    header: 'COMMERCIAL_SERVICES.LABEL.FACILITY_ID',
    mobileHeader: 'COMMERCIAL_SERVICES.LABEL.FACILITY_ID',
    formatPattern: 'text',
    type: 'input',
    width: '9%',
    sortable: true,
    filterable: true,
    matchMode: 'equals',
  },
  {
    field: 'category',
    header: 'COMMERCIAL_SERVICES.LABEL.NOTE_CATEGORY',
    mobileHeader: 'COMMERCIAL_SERVICES.LABEL.NOTE_CATEGORY',
    formatPattern: 'text',
    type: 'input',
    width: '12%',
    sortable: true,
    filterable: true,
    matchMode: 'contains',
  },
  {
    field: 'aorName',
    header: 'LOCATION.LABEL.AOR',
    mobileHeader: 'LOCATION.LABEL.AOR',
    formatPattern: 'text',
    type: 'input',
    width: '11%',
    sortable: true,
    filterable: true,
    matchMode: 'contains',
  },
  {
    field: 'contactName',
    header: 'CRM.LABEL.CONTACT',
    mobileHeader: 'CRM.LABEL.CONTACT',
    formatPattern: 'text',
    type: 'input',
    width: '12%',
    sortable: true,
    filterable: true,
    matchMode: 'contains',
  },
  {
    field: 'comments',
    header: 'CRM.LABEL.COMMENTS',
    mobileHeader: 'CRM.LABEL.COMMENTS',
    formatPattern: 'text',
    type: 'input',
    width: '30%',
    sortable: false,
    filterable: true,
    matchMode: 'contains',
  },
];
